import i18n from "@/i18n";
import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query"
import { createRouter, createWebHistory } from "vue-router";
import { pinia } from "~/store";
import "~/css/style.scss"
import App from "./App.vue";

const router = createRouter({
    history: createWebHistory(""),
    routes: [
        {
            path: "/:catchAll(.*)",
            component: App,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { top: 0 };
    },
});

const app = createApp(App);
app.use(pinia);
app.use(i18n);
app.use(router);
app.use(VueQueryPlugin);

app.mount("#timetable");
